import type { Dayjs } from 'dayjs'

import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { ClientBookingSubscriptionStatusMessage } from '@/src/domains/client-booking/components/ClientBookingSubscriptionStatus/ClientBookingSubscriptionStatusMessage'

import { useClientBookingSubscriptionStatusRedesigned } from './useClientBookingSubscriptionStatusRedesigned'

export interface ClientBookingSubscriptionStatusRedesignedProps {
  month: Dayjs
  therapist: TherapistType
  service: ServiceType
}

export const ClientBookingSubscriptionStatusRedesigned = ({
  month,
  therapist,
  service,
}: ClientBookingSubscriptionStatusRedesignedProps) => {
  const message = useClientBookingSubscriptionStatusRedesigned({ month, therapist, service })

  if (!message) {
    return null
  }

  return <ClientBookingSubscriptionStatusMessage {...message} />
}
